import * as yup from 'yup';
import { AppCtaComponent } from '@web/components/AppCTAComponent';
import {
  requiredImageFromCMSSchema,
  nullableImageFromCMSSchema,
} from '../schemas';

export const component = AppCtaComponent;

export const AppLinkSchema = yup
  .object({
    link: yup.string(),
    image: requiredImageFromCMSSchema,
  })
  .transform(value => ({
    link: value.link,
    image: value.image,
  }));

export const schema = yup
  .object({
    heading: yup.string().required(),
    subheading: yup.string(),
    image: requiredImageFromCMSSchema,
    mobileImage: nullableImageFromCMSSchema,
    imageAlignment: yup.string(),
    appLinks: yup.array(AppLinkSchema),
    level: yup.string(),
  })
  .transform(value => ({
    heading: value.heading,
    subheading: value.subheading,
    image: value.image,
    mobileImage: value.mobile_image,
    imageAlignment: value.image_alignment ? value.image_alignment : 'left',
    appLinks: value.app_links,
    level: value.level,
  }));
